export class DocumentSideBarConsts {
	public static AOTMiTPPZ: string = 'aotmitPPZ';
	public static AOTMiTRecommendations: string = 'aotmitRecommendations';
	public static AOTMiTAnnex: string = 'aotmitAnnex';
	public static AOTMiTPronouncement = 'aotmitPronouncements';
	public static AOTMiTFinalReport = 'aotmitFinalReport';
}
